import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listBrokers, listAgencies } from './../actions/brokers';
import { listCovers } from './../actions/openCovers';
import BlankState from './../components/BlankState';

class BuyQoute extends Component {
  componentDidMount() {
    const { listAgencies, listBrokers, listCovers } = this.props;
    this.getCovers();
    listAgencies();
  }
  getCovers() {
    const { userRole, listCovers } = this.props;
    if (userRole && userRole[0] === 'intermediary_admin') {
      const filter = {
        intermediary: this.props.user ? this.props.user.userInfo.company : null
      };
      listCovers(filter);
    }
  }
  render() {
    const {
      userRole,
      user,
      onChangeBrokers,
      onchangeAgencies,
      disabledBrokers,
      disabledAgencies,
      onChangeCover
    } = this.props;

    const { brokers, agencies } = this.props.brokers || {};
    const { openCovers, coversLoading } = this.props.covers;
    return (
      <div>
        {userRole === '' || userRole === null ? (
          <div>
            <div className="form-group">
              <label className="col-sm-4 control-label">Select a Broker</label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <select
                    id="broker"
                    name="broker"
                    className="form-control"
                    onChange={onChangeBrokers}
                    disabled={disabledBrokers}
                  >
                    <option value="">Select a Broker </option>
                    {brokers &&
                      brokers.map((broker, index) => {
                        return (
                          <option key={index} value={broker.id}>
                            {broker.name}
                          </option>
                        );
                      })}
                  </select>
                  {brokers === '' ? (
                    <div className="text-danger">Select a Broker</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-4 control-label">Select an Agent</label>
              <div className="col-sm-8">
                <div className="clearfix">
                  <select
                    id="agent"
                    name="agent"
                    className="form-control"
                    onChange={onchangeAgencies}
                    disabled={disabledAgencies}
                  >
                    <option value="">Select an Agent</option>
                    {agencies &&
                      agencies.map((agency, index) => {
                        return (
                          <option key={index} value={agency.id}>
                            {agency.name}
                          </option>
                        );
                      })}
                  </select>
                  {agencies === '' ? (
                    <div className="text-danger">Select an Agent</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {userRole[0] === 'intermediary_admin' ? (
          <div>
            {openCovers.length > 0 ? (
              <div className="form-group">
                <label className="col-sm-4 control-label">Open Cover</label>
                <div className="col-sm-8">
                  <div className="clearfix">
                    <select
                      id="openCover"
                      name="openCover"
                      className="form-control"
                      onChange={onChangeCover}
                    >
                      <option value="">Select open Cover </option>
                      {openCovers &&
                        openCovers.map((openCover, index) => {
                          return (
                            <option key={index} value={openCover.id}>
                              {openCover.company_name}
                            </option>
                          );
                        })}
                    </select>
                    {brokers === '' ? (
                      <div className="text-danger">Select a Broker</div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  brokers: state.brokers,
  user: state.user,
  covers: state.covers
});
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      listBrokers,
      listAgencies,
      listCovers
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuyQoute);



// WEBPACK FOOTER //
// ./src/components/BuyQuote.js